import gql from 'graphql-tag';
import { client } from '../../apollo';
import { loadingAlert, closeSwal } from '../../Common/alerts';
import { copy, getAmount, getDate } from '../../Common/utils';

function __get_copy(payload) {
  const payload_copy = copy(payload)
  payload_copy['amount'] = getAmount(payload_copy['amount']);
  payload_copy['dueDate'] = getDate(payload_copy['dueDate']);

  return payload_copy
}

export async function zwalletPaymentGraphQL(data) {
  const { payload, user } = data;

  const CREATE_PAYMENT = gql`
    mutation CreatePayment($barcode: String!, $description: String!, $account: String) {
      createPayment(barcode: $barcode, description: $description, account: $account) {
        value
        dueDate
        totalValue
        penalty
        interest
        discount
        protocol
      }
    }
  `;

  // 876600000023030358281910516008258043611320074630 (suportado)
  // 23793381286000667680724000063305278980000002000 (não suportado)
  const payload_copy = copy(payload)

  const variables = {
    barcode: payload_copy.barcode,
    description: payload_copy.description,
    account: user.zwalletUser.accounts[0].id
  }

  try {
    loadingAlert("Envio", "Processando, por favor aguarde!")
    const { data } = await client.mutate({
      mutation: CREATE_PAYMENT,
      variables
    });
    closeSwal();

    return data.createPayment;
  } catch(error) {
    const msg = error.message.replace("GraphQL error: ", "")
    console.log(msg);
    closeSwal();
    throw msg
  }
}

export async function zwalletPaymentNotSupportedGraphQL(data) {
  const { payload, user } = data;

  const CREATE_PAYMENT = gql`
    mutation CreatePaymentNotSupported($input: CreatePaymentNotSupportedInput!) {
      createPaymentNotSupported(data: $input) {
        protocol
      }
    }
  `;

  payload['account'] = user.zwalletUser.accounts[0].id
  const variables = {'input': __get_copy(payload)}

  try {
    loadingAlert("Pagamento", "Enviando pagamento")
    const { data } = await client.mutate({
      mutation: CREATE_PAYMENT,
      variables
    });

    return data.createPaymentNotSupported.protocol;
  } catch(error) {
    const msg = error.message.replace("GraphQL error: ", "")
    console.log(msg);
    throw msg
  }
}

export async function zwalletPaymentConfirmGraphQL(data) {
  const { protocol, dueDate } = data;

  const CONFIRM_PAYMENT = gql`
    mutation ConfirmPayment($protocol: String!, $dueDate: Date) {
      confirmPayment(protocol: $protocol, dueDate: $dueDate) {
          success
          message
          protocol
      }
    }
  `;


  const variables = {
    'protocol': protocol,
    'dueDate': getDate(dueDate)
  }

  try {
    loadingAlert("Pagamento", "Enviando pagamento")
    const { data } = await client.mutate({
      mutation: CONFIRM_PAYMENT,
      variables
    });

    if (!data.confirmPayment.success) {
      throw data.confirmPayment
    }

    return data.confirmPayment.protocol;
  } catch(error) {
    const msg = error.message.replace("GraphQL error: ", "")
    console.log(msg);
    throw msg
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/graphql.js